module.exports = __webpack_public_path__ + "img/img38.12f73519.svg";